import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

export default definePreset(Lara, {
  primitive: {
    red: {
      50: '#FFF5F2',
      100: '#FFE6E0',
      200: '#FFC2B3',
      300: '#FF9C86',
      400: '#FF7059',
      500: '#CA2F09',
      600: '#A62408',
      700: '#831D06',
      800: '#5C1404',
      900: '#3D0D02',
      950: '#1F0601',
    },
  },
  semantic: {
    primary: {
      50: '#9FAFFF',
      100: '#8A9EFF',
      200: '#617CFF',
      300: '#395AFF',
      400: '#1038FF',
      500: '#0027E6',
      600: '#001DAE',
      700: '#001476',
      800: '#000A3E',
      900: '#000106',
      950: '#000000',
    },
    colorScheme: {
      focusRing: {
        shadow: 'none',
      },
      formField: {
        color: '{gray.900}',
        hoverBorderColor: '{surface.400}',
      },
    },
  },
  components: {
    button: {
      root: {
        label: {
          fontWeight: 'normal',
        },
      },
      colorScheme: {
        outlined: {
          secondary: {
            borderColor: '{surface.300}',
            color: '{surface.700}',
          },
        },
      },
    },
    togglebutton: {
      root: {
        fontWeight: '500',
      },
      colorScheme: {
        checkedBackground: '{primary.500}',
        checkedColor: 'white',
        checkedBorderColor: '{primary.500}',
      },
    },
    tabs: {
      tab: {
        fontWeight: 600,
        border: {
          width: '0 0 2px 0',
        },
      },
    },
  },
});
